<template>
  <div class="fixed inset-0 bg-gray-500 bg-opacity-75 flex items-center justify-center z-50">
    <div class="bg-white p-8 rounded-lg shadow-lg md:w-2/4 w-96 ">
      <div class="flex items-center">
        <h2 class="md:text-2xl text-xl font-bold text-red-600">Share your basket by QR code</h2>
      </div>
      <div class="py-4 text-lg">
        <p>Scan this QR to share your basket with friends!</p>
        <p>Alternatively, the link has been copied to your clipboard.</p>
      </div>

    <div class="flex flex-col items-center space-y-2">
      <img 
        :src="`https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(shareBasketUrl)}`"
        alt="Share Your Snapshot Basket with a QR Code" 
      />
    </div>
    <div class="mt-6 flex justify-between">
        <button @click="$emit('close')" class="bg-red-500 text-white py-2 px-4 rounded hover:bg-gray-600">
        Close
        </button>
    </div> 
    </div>
  </div>
</template>

<script>

export default {
  name: "QRCodeShareModal",
  props: {
    shareBasketUrl: {
      type: String,
      required: true
    }
  },
  methods: {
    closeShareModal() {
      this.$emit("closeShareModal");
    }
  }
}
</script>